import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LandingPage } from './Landing/Landing';
import { SiteContextProvider } from './Context/SiteContext';
import { InterfaceScroller } from './Components/Interface';
import { SavantGarde } from './SavantGarde/SavantGarde';
import { ProvenceSection } from './Provence/Provence';
import { Gallery } from './Gallery/Gallery';
import { BrowserRouter, Route, Routes } from 'react-router';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <SiteContextProvider>
            <BrowserRouter>
                <Routes>
                    <Route path='/portfolio' element={<Gallery></Gallery>}></Route>
                    <Route path='*' element={
                        <div
                            style={{
                                display:'flex',
                                height:'100vh',
                                width:'100vw',
                                overflow:'hidden',
                            }}
                        >
                            <InterfaceScroller scrollerStyle={{padding:0,}}>
                            <LandingPage></LandingPage>
                            <SavantGarde></SavantGarde>
                            <ProvenceSection></ProvenceSection>
                            </InterfaceScroller>
                        </div>
                    }></Route>
                </Routes>
            </BrowserRouter>
        </SiteContextProvider>
  </React.StrictMode>
);
